module.exports = __webpack_public_path__ + "static/media/gs1.0011b9fe.png";